// extracted by mini-css-extract-plugin
export default {"content":"poll-success-page_content__ztzd-","folded-hands":"poll-success-page_folded-hands__6CN2d","modal":"poll-success-page_modal__prQ85"};